<script setup lang="ts">
import {  RouterView } from 'vue-router'
import { cs } from './utils/cs'

cs()
</script>

<template>
  <RouterView />
</template>

